import { StateMessage } from '@/components/StateMessage/StateMessage';
import styles from './PlaceholderPage.module.css';

export function PlaceholderPage({ title, phase }: { title: string; phase: string }) {
  return (
    <div className={styles.wrap}>
      <StateMessage title={title}>
        Komt in {phase}. De navigatie blijft beschikbaar zodat het hub-ontwerp compleet voelt.
      </StateMessage>
    </div>
  );
}
